import { useEffect, useState } from 'react'
import { cloneDeep } from 'lodash'
import { useAppSelector } from 'app-redux/hooks'

import { SortOptionType } from 'types/deck'
import { CardType } from 'types/deck'

import { SortFunctionMap } from 'app-redux/deck/helpers/sorting'

const useCardFilterAndSort = (
  cardList: CardType[],
  orderBy: SortOptionType,
  sortDirectionDescending: boolean,
  filteredCards: string[],
) => {
  const priceSource = useAppSelector(state => state.active.priceSource)

  const sortFunction = SortFunctionMap[orderBy]

  let cards = cloneDeep(cardList)

  if (filteredCards.length !== 0) {
    cards = cards.reduce((acc, card) => {
      if (filteredCards.includes(card.name)) acc.push(card)
      return acc
    }, new Array<CardType>())
  }

  cards.sort((cardA, cardB) => sortFunction(cardA, cardB, priceSource))
  if (sortDirectionDescending) cards.reverse()

  return cards
}

export default useCardFilterAndSort
